import { LineItemDto, PricingMethodType, MaterialLineItemDto } from '../dtos';
import { BilledToType } from '../dtos/enums/BilledToType';
import { LineItemTypes } from './constants';

export const getDefaultPricingMethod = (lineItem?: LineItemDto): PricingMethodType => {
    return lineItem?.type === LineItemTypes.Material
        ? ((lineItem as MaterialLineItemDto).isBilledTo === BilledToType.Customer || (lineItem as MaterialLineItemDto).isBilledTo === BilledToType.Custom)
            ? PricingMethodType.HaulOnly
            : PricingMethodType.Standard
        : PricingMethodType.Standard;
};
